// Login.js

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateUser } from '../actions/user-actions';
import { history } from '../helpers/history';

class VerifyEmail extends Component {
    constructor(props) {
      super(props);
      this.state = {
        message: null,
        messageType: 'alert alert-success'
      }
    }
  
    componentDidMount() {
        var response = fetch("https://beiseker.bookice.ca/api/v0/verifyEmail/"+this.props.match.params.id, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        })
        .then(response => {
          if (!response.ok) {
              console.log(response.statusText);
              return Promise.reject(response.statusText);
          }
          console.log(response.statusText);
          return response.json();
      })
      .catch(error => {
        console.log(error);
        this.state.message = "Unable to verify your email address";
        this.state.messageType = 'alert alert-warning';
        return null;
      })
      .then(json => {
          if (json && json.token) {
              console.log('token', json);
              console.log('updating... in onSubmit:', json);
              this.state.message = "Email address verified!  You are now logged in";
              this.props.onUpdateUser(json);
          } else {
            this.state.message = "Unable to verify your email address";
            this.state.messageType = 'alert alert-warning';
          }
      });
    }

    onUpdateUser(token){
      console.log('updating... in login page:', token);
      this.props.onUpdateUser(token);
    }
  
    onBackClick() {
      history.push('/calendar')
    }
    render() {
  
      return (
          <div>
                <div className="container">
                    <div className="col-sm-6 offset-sm-3 mt-2">
                        {this.state.message &&
                            <div className={this.state.messageType}>{this.state.message}</div>
                        }
                    </div>
                </div>
            <div>
            <button className='btn btn-info' onClick={this.onBackClick}>Back</button>
            </div>
          </div>
      );
    }
  
}

const mapStateToProps = state => ({
  user: state.user
});

const mapActionsToProps = {
  onUpdateUser: updateUser
};


export default connect(mapStateToProps, 
  mapActionsToProps
  )(VerifyEmail);


// WEBPACK FOOTER //
// ./src/components/VerifyEmail.js